<template>
    <div>
        <breadCrumb 
            :icon="'fa-cog'"
            :category="$t(`sideNav.navMySalon`)"
            :subCategory="$t(`subMenu.my_salon_branding`)"
            :subSubCategory="$t(`brand_submenu.brand_setup_general`)">
        </breadCrumb>
        <div class="px-3 px-sm-5 py-4" :key="brandGeneralInfoKey">
            <div class="panel mb-0">
                <div class="panel-hdr">
                    <h2>{{$t('branding.header_general')}}</h2>
                </div>
                <div class="panel-container">
                    <div class="panel-content">
                        <form @submit.prevent="setGeneralInfo">
                            <div class="row">
                                <div class="col-lg-6 col-xl-6 p-5 border-right">
                                    <div class="form-group">
                                        <label class="form-label">{{$t('label.brand_name')}}</label>
                                        <div class="input-group bg-white shadow-inset-2">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text bg-transparent border-right-0">
                                                    <i class="fas fa-home"></i>
                                                </span>
                                            </div>
                                            <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.brand_name')" v-model="name">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label">{{$t('label.contact')}}</label>
                                        <div class="input-group bg-white shadow-inset-2">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text bg-transparent border-right-0">
                                                    <i class="fas fa-phone-alt"></i>
                                                </span>
                                            </div>
                                            <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.contact')" v-model="contact" @keyup="contactValidation">
                                        </div>
                                        <div id="err" class="error-validation"></div>
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label">{{$t('label.about')}}</label>
                                        <textarea class="form-control" rows="5" v-model="about"></textarea>
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label">{{$t('label.motto')}}</label>
                                        <textarea class="form-control" rows="5" v-model="motto"></textarea>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-xl-6 p-5">
                                    <div class="border-bottom"><label class="form-label">{{$t('label.logo')}}</label></div>
                                    <div id="brandLogoContainer" class="text-center pt-5">
                                        <a id="brandLogo" @click="handleDropzone('brand-logo', 'brandLogo')" :title="$t('button_link.click_upload') + $t('branding.brand_logo')" class="m-auto">
                                            <img class="img-fluid brand-logo rounded-circle" :src="getBrandLogo()"/>
                                            <p class="mt-1 text-dark fw-500">{{$t('branding.brand_logo')}}</p>
                                        </a>
                                        <a id="receiptLogo" @click="handleDropzone('brand-logo', 'receiptLogo')" :title="$t('button_link.click_upload') + $t('branding.receipt_logo')" class="m-auto">
                                            <img class="img-fluid brand-logo rounded-circle" :src="getReceiptLogo()"/>
                                            <p class="mt-1 text-dark fw-500">{{$t('branding.receipt_logo')}}</p>
                                        </a>
                                    </div>
                                    <div v-if="dzShow" class="mt-2"> 
                                        <div class="row">
                                            <div class="col">
                                                <h6 class="text-dark fs-sm">{{$t('button_link.upload')}}
                                                    <span class="fw-500">{{logoType == 'Brand Logo' ? $t('branding.brand_logo') : $t('branding.receipt_logo')}}</span>
                                                </h6>
                                            </div>
                                            <div class="col text-right">
                                                <a class="cancel" @click="handleDropzone('profile-image', '')">{{$t('button_link.cancel')}}</a>
                                            </div>
                                        </div>
                                        <vue-dropzone class="text-center" id="dropLogo" :options="dropOptions" @vdropzone-success="dropLogo"></vue-dropzone>
                                        <div v-show="showCropper" id="brandLogoCropper" class="logo-cropper">
                                            <a id="cropDoneBtn" class="btn btn-default btn-sm btn-icon waves-effect waves-themed"><i class="fal fa-check"></i></a>
                                            <a class="btn btn-danger btn-sm btn-icon waves-effect waves-themed ml-5" @click="handleDropzone('profile-image')"><i class="fal fa-times text-white"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-left ml-3 mb-3">
                                <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.save')}}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BreadCrumb from './../../Bread_Crumb'
import vueDropzone from "vue2-dropzone";
import Cropper from 'cropperjs';
import {contactValidation, getMessage} from './../../../../assets/js/dashboard/utilities'
import {getRoundedCanvas}  from './../../../../assets/js/dashboard/helper'
import {handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'
export default {
    name: 'brandGeneral',
    components: {
        vueDropzone, BreadCrumb
    },
    data(){
        let $vm = this;
        return{
            name: "", contact: "", about: "", motto: "", icon: "", receiptIcon: "",
            logoTitle: ["Brand Logo", "Receipt Logo"], logoType: "",
            dzShow: false, showCropper: false,
            brandGeneralInfoKey: 0,
            dropOptions: {
                url: this.$api.API_IMAGE,
                transformFile: function (file, done){
                    $vm.showCropper = true;
                    var dropZone = this;
                    var editor = document.getElementById('brandLogoCropper')

                    var image = new Image();
                    image.src = URL.createObjectURL(file);
                    editor.appendChild(image);

                    var cropper = new Cropper(image, { aspectRatio: 1 });

                    document.getElementById('cropDoneBtn').onclick = function(){
                        var croppedCanvas = cropper.getCroppedCanvas();
                        var roundedCanvas = getRoundedCanvas(croppedCanvas);
                        
                        roundedCanvas.toBlob(function (blob){
                            dropZone.createThumbnail(
                                blob,
                                dropZone.options.thumbnailWidth,
                                dropZone.options.thumbnailHeight,
                                dropZone.options.thumbnailMethod,
                                false, 
                                function(dataURL) {
                                
                                dropZone.emit('thumbnail', file, dataURL);
                                done(blob);

                            })
                            $vm.showCropper = false;
                        })
                        
                    }
                },
                thumbnailWidth: 180,
                thumbnailHeight: 180,
                addRemoveLinks: true,
                maxFiles: 1,
                paramName: 'filename',
                headers:{
                    token: this.$util.getSessionToken()
                }
            }
        }
    },
    methods:{
        closeModal(isError){
            if(!isError){
                this.getGeneralInfo()
                this.brandGeneralInfoKey += 1;
            }
            this.$parent.isModalShow = false
        },
        getBrandLogo(){
            return this.icon;
        }, 
        getReceiptLogo(){
            return this.receiptIcon;
        }, 
        getGeneralInfo(){
            let $vm = this;
            $vm.$axios({
                method: 'get', 
                url: $vm.$api.BRAND_SETTING,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                var results = response.data;
                $vm.name = results.name;
                $vm.contact = results.contact;
                $vm.about = results.about;
                $vm.motto = results.motto;
                $vm.icon = results.icon;
                $vm.receiptIcon = results.receiptIcon;
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        },
        contactValidation(){
            var err = contactValidation(this.contact);
            document.getElementById('err').innerHTML = err == null ? null : this.$i18n.t('message.contact_validation.phone_number', {
                'error':  this.$i18n.t(`message.contact_validation.error.${err}`)
            })
        },
        handleDropzone(strClass, logoType){
            this.showCropper = false;
            var parent = document.getElementById("brandLogoContainer");
            const imgs = parent.getElementsByClassName(strClass);

            switch(logoType){
                case"brandLogo":
                this.logoType = "Brand Logo"
                break;
                case"receiptLogo":
                this.logoType = "Receipt Logo"
                break;
                default: 
                this.logoType = ""
                break;
            }
            
            var j = 0;
            if(imgs.length > 0){
                for(var i=0; i<imgs.length;){
                    var img = imgs[i];
                    var p = img.nextSibling
                    var link = img.parentElement;

                    if(img.classList.contains('brand-logo')){
                        img.classList.remove('brand-logo');
                        img.classList.add('profile-image');

                        link.classList.remove('m-auto');
                        link.classList.add('mr-2');
                        link.setAttribute('title', '');
                        parent.classList.add('d-flex');

                        if(link.id != logoType){
                            p.classList.remove('text-dark')
                            p.classList.remove('fw-500')
                            p.classList.add('text-secondary')

                            img.style.opacity = "0.5"
                        }
                        this.dzShow = true;
                    }else{
                        img.classList.add('brand-logo');
                        img.classList.remove('profile-image');

                        link.classList.add('m-auto');
                        link.classList.remove('mr-2');
                        link.setAttribute('title', this.$i18n.t('button_link.click_upload') + (this.logoTitle[j] == 'Brand Logo' ? this.$i18n.t('branding.brand_logo') : this.$i18n.t('branding.receipt_logo')) );
                        parent.classList.remove('d-flex')

                        p.classList.remove('text-secondary')
                        p.classList.add('text-dark')
                        p.classList.add('fw-500')

                        img.style.opacity = "1"

                        this.dzShow = false;
                    }
                    j++;
                }
            }
        },
        setGeneralInfo(){
            var data = {
                name: this.name,
                contact: this.contact,
                about: this.about,
                motto: this.motto
            }
            this.editGeneralInfo(data, false)
        },
        dropLogo(file, response){
            if(response.path == undefined){
                var message = getMessage('image', false);
                this.setModal(true, true, message);
            }
            var data = {}
            if(this.logoType == 'Brand Logo'){
                data.icon = response.path
            }else{
                data.receiptIcon = response.path
            }
            this.editGeneralInfo(data, true)
        },
        editGeneralInfo(data, isUpload){
            let $vm = this
            this.$axios({
                method: 'post', 
                url: this.$api.BRAND_SETTING,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: this.$util.getSessionToken()},
                data: data
            })
            .then((response) => {
                if(response.status == 200){
                    var message = "";
                    if(isUpload){
                        $vm.$parent.setModal($vm, false, true, $vm.$i18n.t('message.success.upload'))
                        $vm.handleSuccessUpload();
                    }else{
                        document.getElementById('modalClose').style.visibility = 'visible';
                        message = $vm.$i18n.t('subMenu.my_salon_branding') + $vm.$i18n.t('branding.header_general') + $vm.$i18n.t('message.success.update');
                        $vm.$parent.setModal($vm, false, true, message);
                    }
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }else{
                    if(isUpload){
                        $vm.$parent.setModal($vm, false, true, $vm.$i18n.t('message.error.upload'))
                    }else{
                        $vm.$parent.setModal($vm, false, true, $vm.$i18n.t('message.error.system_error'))
                    }
                }
            })
        },
        handleSuccessUpload(){
            this.dzShow = false;
            this.getGeneralInfo();
            this.brandGeneralInfoKey += 1;
        },
    },
    mounted(){
        let $vm = this;
        $vm.getGeneralInfo();
    }
}
</script>

<style scoped>
.brand-logo{
    width: 12em;
    cursor: pointer;
}
.cancel{
    cursor: pointer;
    color: #777;
}
.show{
    display: block;
}
.error-validation{
    font-size: 0.6875rem;
    margin-top: 0.325rem;
    color: #fd3995;
}
.logo-cropper{
    position: absolute;
    inset: 8em 0em;
    z-index: 9999;
    margin-top: 5em;
}
.logo-cropper > .btn{
    position: absolute;
    top: 2%;
    left: 1%;
    z-index: 999;
}
.cropper-crop-box{
  border-radius: 50% !important;
}
</style>